<script>
import Component from '~/sites/cvb/pages/_'
export default {
  extends: Component,
  async asyncData(context) {
    const fullPath = context.route.fullPath
    if (fullPath.startsWith('/article')) {
      const slug = fullPath.replace('/article/', '')
      return context.redirect(context.app.localePath({ name: 'article-slug', params: { slug: slug }, locale: 'de' }))
    }

    return await Component.extends.asyncData(context)
  },
}
</script>
